import {Component, HostListener, ElementRef, AfterViewInit, ChangeDetectionStrategy, input, output, viewChild} from '@angular/core'
import { TranslocoDirective } from '@jsverse/transloco'
import { BaseIconComponent, LUCIDE_ICONS } from '../../base/base-icon/base-icon.component'

@Component({
	selector: 'app-modal',
	imports: [TranslocoDirective, BaseIconComponent],
	templateUrl: './modal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './modal.component.css'
})
export class ModalComponent implements AfterViewInit {
	readonly closable = input<boolean | undefined>(true)
	readonly show = input(true)

	/** Light is the auth modal's surface; every other modal is dark. */
	readonly surface = input<'dark' | 'light'>('dark')

	public readonly CloseIcon = LUCIDE_ICONS['X']

	readonly closed = output<void>()

	// Not required: the trap lives inside @if (show()), so a closed modal has no
	// element and viewChild.required() would throw instead of answering undefined.
	readonly focusTrapRef = viewChild<ElementRef<HTMLDivElement>>('focusTrap')

	@HostListener('document:keydown.escape')
	onKeyDownEscape(): void {
		this.handleKeydownEscape()
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.focusTrapRef()?.nativeElement.focus()
		})
	}

	onOverlayClick(event: MouseEvent): void {
		if ((event.target as HTMLElement).classList.contains('modal-overlay')) {
			if (this.closable() !== false ) {
				this.closed.emit()
			}
		}
	}

	private handleKeydownEscape() {
		// ESC key closes modal
		if (this.closable() !== false) {
			this.closed.emit()
		}
	}
}

